import { useEffect } from "preact/hooks";

export function useVideoTime(callback: (videoTime: number) => void) {
  useEffect(() => {
    function handler(event: MessageEvent) {
      if (event.data.src !== "3PLAYERS_ACCESS_PLAYER") return;
      if (event.data.type !== "CURRENT_TIME") return;
      callback(event.data.value);
    }
    window.addEventListener("message", handler);

    return () => {
      window.removeEventListener("message", handler);
    };
  }, [callback]);
}
